<template>
    <div class="modal fade" id="share-dialog" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body p-5">
                    <div class="row">
                        <div class="col-12">
                            <h3><strong>{{ $t('plan_trail.share_modal.share_your_plan') }}</strong></h3>
                            <p class="text-muted d-flex">{{ $t('plan_trail.share_modal.copy_the_link_below_and_share') }} <span class="text-yellow ml-2" id="copyConfirm" style="display: none">{{ $t('plan_trail.share_modal.copied') }}</span></p>
                            <div class="input-group my-3" id="copyURLInputGroup">
                                <input :value="this.$store.state.planTrail.shareableUrl" class="form-control" id="trailShareInput"/>
                                <div class="input-group-append">
                                <span class="input-group-text btn btn-secondary" role="button" @click="copyToClipboardClicked">
                                    <span class="material-icons">
                                    content_copy
                                    </span>
                                </span>
                                </div>
                            </div>
                            <button class="btn btn-secondary mr-2" data-bs-dismiss="modal">{{ $t('shared.close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import copyToClipboard from '../../../utils/helpers/CopyToClipboardHelper';

export default defineComponent({
  data() {
    return {};
  },
  methods: {
    copyToClipboardClicked() {
      copyToClipboard(this.$store.state.planTrail.shareableUrl, (success, error) => {
        if (error) alert(error);
      });
    },
  },
});
</script>
